import * as PIXI from 'pixi.js';

import Tappable from './Tappable';

export default class TappableTextureButton extends Tappable {
    constructor(opts) {
        super(opts);

        const {
            texture, width, height, text, textOffsetY = 0,
            fontColor = '#ffffff', fontFill = null,
            fontSize = 35, fontFamily = 'Open Sans', fontWeight = 'bold',
            fontStrokeColor = '#000000', fontSpacing = 0, fontStrokeWidth = 0,
        } = opts;

        this.layout = {
            width: width,
            height: height,
        };

        this.hitArea = new PIXI.Rectangle(0, 0, width, height);

        this.onTap = () => {
            this.onButtonTap?.();
        };

        const scaleContainer = new PIXI.Container();
        scaleContainer.x = width / 2;
        scaleContainer.y = height / 2;
        this.addChild(scaleContainer);

        this.onHoldStart = () => {
            scaleContainer.scale.set(0.9);
        };

        this.onHoldEnd = () => {
            scaleContainer.scale.set(1);
        };

        const sprite = new PIXI.Sprite(texture);
        sprite.width = width;
        sprite.height = height;
        sprite.anchor.set(0.5);
        scaleContainer.addChild(sprite);

        if (text) {
            const buttonText = new PIXI.Text({
                text,
                style: {
                    fontFamily,
                    fontSize,
                    fill: fontFill ?? fontColor,
                    fontWeight,
                    letterSpacing: fontSpacing,
                    stroke: { color: fontStrokeColor, width: fontStrokeWidth },
                },
            });
            buttonText.anchor.set(0.5);
            buttonText.y = textOffsetY;
            scaleContainer.addChild(buttonText);
            this.buttonText = buttonText;
        }
    }
}